import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { api, type UserAuth } from "./api";

interface AuthState {
  user: UserAuth | null;
  loading: boolean;
}

const AuthCtx = createContext<AuthState>({ user: null, loading: true });

/** Provides the current authenticated user to the React tree. */
export function AuthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AuthState>({ user: null, loading: true });

  useEffect(() => {
    let cancelled = false;
    api
      .me()
      .then((user) => {
        if (!cancelled) setState({ user, loading: false });
      })
      .catch(() => {
        // 401 already triggered the SSO redirect inside the fetcher.
        if (!cancelled) setState({ user: null, loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <AuthCtx.Provider value={state}>{children}</AuthCtx.Provider>;
}

/** Returns the current authenticated user, or null while loading. */
export function useUser() {
  return useContext(AuthCtx);
}
